/**
 * PopupContent - Reusable popup body wrapper
 * 
 * Props:
 * - children: Content to render inside
 * - maxHeight: Max height before scrolling (default: none)
 * - className: Additional CSS class
 * - style: Additional inline styles
 */
function PopupContent({ 
  children, 
  maxHeight = null,
  className = "",
  style = {} 
}) {
  const contentStyle = {
    ...(maxHeight && { maxHeight }),
    ...style
  };

  return (
    <div 
      className={`popup-content ${className}`}
      style={Object.keys(contentStyle).length > 0 ? contentStyle : undefined}
    >
      {children}
    </div>
  );
}

export default PopupContent;
